import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import pickBy from 'lodash/pickBy';
import { Motion } from 'react-motion';
import { EMPTY_OBJECT } from '../../constants';
import { springify } from '../../lib/Motion';
import { sortByContrast } from '../../lib/Color';
import { withHover } from '../Hoverable';
import { Search } from '../Icons';
import Style from '../Style';

const animatedDefault = {
  hover: 0,
  iconOnly: 0,
};

class SearchButton extends React.PureComponent {
  static propTypes = {
    iconOnly: PropTypes.bool,
    baseColor: PropTypes.string,
    lightColor: PropTypes.string,
    darkColor: PropTypes.string,
    hover: PropTypes.bool,
    enabled: PropTypes.bool,
    onClick: PropTypes.func,
    border: PropTypes.bool,
    style: PropTypes.object,
    children: PropTypes.node,
  };
  static defaultProps = {
    iconOnly: false,
    baseColor: Style.Colors.white,
    lightColor: Style.Colors.white,
    darkColor: Style.Colors.black,
    hover: false,
    enabled: true,
    onClick: () => {},
    border: true,
    style: EMPTY_OBJECT,
    children: ' ',
  };

  render() {
    const {
      iconOnly,
      lightColor,
      darkColor,
      baseColor,
      hover,
      enabled,
      onClick,
      border,
      style,
      children,
      ...otherProps
    } = this.props;

    let sizeParams = {
      height: 5,
      borderWidth: 0.4,
      fontSize: '2.2rem',
      letterSpacing: '-0.15px',
    };

    const [colorB, colorA] = sortByContrast([lightColor, darkColor], baseColor);

    const {
      fontWeight,
      fontStyle,
      letterSpacing,
      lineHeight,
      fontSize,
      ...otherStyles
    } = style;

    let buttonStyle = {
      height: `${sizeParams.height}rem`,
      borderRadius: '99999rem',
      borderStyle: 'solid',
      borderWidth: border ? `${sizeParams.borderWidth}rem` : 0,
      borderColor: colorA,
      cursor: enabled ? 'pointer' : 'not-allowed',
      ...otherStyles,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    };

    let labelStyle = pickBy(
      {
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        fontSize: fontSize,
        margin: 0,
        position: 'relative',
        top: '-0.1rem',
      },
      value => value !== undefined,
    );

    let workingStyle = {
      maxWidth: `${sizeParams.height * 0.7}rem`,
    };

    const hovering = hover && enabled;
    const animatedCurrent = {
      hover: hovering ? 1 : animatedDefault.hover,
    };
    const animatedCurrentIconOnly = {
      iconOnly: iconOnly ? 1 : animatedDefault.iconOnly,
    };

    return (
      <Motion
        defaultStyle={animatedDefault}
        style={{
          ...springify(animatedCurrent, {
            stiffness: hovering ? 180 : 100,
            damping: hovering ? 25 : 35,
          }),
          ...springify(animatedCurrentIconOnly, {
            stiffness: iconOnly ? 200 : 200,
            damping: iconOnly ? 70 : 30,
          }),
        }}
      >
        {tween => {
          const iconOnlyInverted = tween.iconOnly * -1 + 1;

          // Animated properties.
          const buttonStyleMerged = {
            ...buttonStyle,
            paddingLeft: `${(sizeParams.height * 0.5 - sizeParams.borderWidth) *
              iconOnlyInverted}rem`,
            paddingRight: `${(sizeParams.height * 0.5 -
              sizeParams.borderWidth) *
              iconOnlyInverted}rem`,
            minWidth: '5.2rem',
            color: Color(colorA)
              .mix(Color(colorB), tween.hover)
              .string(),
            backgroundColor: Color('transparent')
              .mix(Color(colorA), tween.hover)
              .string(),
          };
          const labelStyleMerged = {
            fontFamily: 'Calibre',
            fontSize: sizeParams.fontSize,
            letterSpacing: sizeParams.letterSpacing,
            fontWeight: 600,
            ...labelStyle,
            pointerEvents: 'none',
            opacity: 1,
            whiteSpace: 'nowrap',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          };
          const textStyle = {
            maxWidth: `${9 * Math.max(iconOnlyInverted * 3 - 2, 0)}rem`,
            opacity: Math.max(iconOnlyInverted * 3 - 2, 0),
          };

          return (
            <button
              disabled={!enabled}
              style={buttonStyleMerged}
              onClick={onClick}
            >
              <span style={labelStyleMerged}>
                <span>
                  <Search
                    color={buttonStyleMerged.color}
                    style={{
                      position: 'relative',
                      // left: `${-2 * iconOnlyInverted}rem`,
                      top: '0.25rem',
                      // paddingRight: '2rem',
                    }}
                  />
                </span>
                <span style={textStyle}>
                  <span style={{ paddingLeft: '1rem' }} />Search
                </span>
              </span>
            </button>
          );
        }}
      </Motion>
    );
  }
}

export default withHover({ wrapper: 'span' })(SearchButton);



// WEBPACK FOOTER //
// ./src/components/SearchButton/SearchButton.js